import React, { ReactNode } from 'react';

type Props = {
  isOpen: boolean;
  onClose?: (e?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  children?: ReactNode,
  className?: string,
};

class Modal extends React.PureComponent<Props> {
  componentDidUpdate(prevProps: Readonly<Props>): void {
    if (prevProps.isOpen !== this.props.isOpen) {
      if (this.props.isOpen) {
        document.body.classList.add('noscroll');
      } else {
        document.body.classList.remove('noscroll');
      }
    }
  }

  render(): ReactNode {
    return (
      <div
        onClick={this.props.onClose}
        className={`modal-background ${this.props.isOpen ? 'show-modal' : ''} ${this.props.className}`}
      >
        <div>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>

            <div className="modal-button-container">
              <button onClick={this.props.onClose} type="button">
                {this.props.onClose
                && (<i className="fa fa-times" />)}
              </button>
            </div>

            <div className="modal-content">
              {this.props.isOpen && this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;
